import { z } from "zod";

// ZOD
export const formSchema = z.object({
  cleaning_costs_events: z.array(z.string()).optional(),
  prices: z
    .array(
      z.object({
        price: z.number(),
        min: z.number(),
        max: z.number(),
        startHour: z.string().optional(),
        endHour: z.string().optional(),
        selectedDay: z.string(),
        type: z.enum(["heure", "soirée", "demi-journée", "journée complète"]),
      })
    )
    .optional()
    .default([]),
  cleaning_costs: z
    .number()
    .nonnegative({
      message: "Les frais de ménage doivent être positifs.",
    })
    .optional(),
  guarantee: z
    .number({
      required_error: "Le montant du dépôt de garantie est obligatoire.",
      invalid_type_error: "Le montant du dépôt de garantie doit être un nombre.",
    })
    .nonnegative({
      message: "Le montant du dépôt de garantie doit être positif.",
    })
    .optional()
    .default(0),
  reservation_type: z
    .string({
      required_error: "La politique d'annulation est obligatoire.",
    })
    .min(1, { message: "La politique d'annulation est obligatoire." }),
  availableDays: z.record(z.boolean()).optional(),
});

// CONSTANTS
export const DAYS_OF_WEEK = [
  { value: "1", label: "Lundi" },
  { value: "2", label: "Mardi" },
  { value: "3", label: "Mercredi" },
  { value: "4", label: "Jeudi" },
  { value: "5", label: "Vendredi" },
  { value: "6", label: "Samedi" },
  { value: "0", label: "Dimanche" },
];

export const HOURS_OPTIONS = [
  { hour: "08:00", value: "8:00" },
  { hour: "09:00", value: "9:00" },
  { hour: "10:00", value: "10:00" },
  { hour: "11:00", value: "11:00" },
  { hour: "12:00", value: "12:00" },
  { hour: "13:00", value: "13:00" },
  { hour: "14:00", value: "14:00" },
  { hour: "15:00", value: "15:00" },
  { hour: "16:00", value: "16:00" },
  { hour: "17:00", value: "17:00" },
  { hour: "18:00", value: "18:00" },
  { hour: "19:00", value: "19:00" },
  { hour: "20:00", value: "20:00" },
  { hour: "21:00", value: "21:00" },
  { hour: "22:00", value: "22:00" },
  { hour: "23:00", value: "23:00" },
];

// HELPERS

export const calculateHourDifference = (startHour: string, endHour: string): number => {
  const [startH, startM] = startHour.split(":").map(Number);
  const [endH, endM] = endHour.split(":").map(Number);
  const startMinutes = startH * 60 + startM;
  const endMinutes = endH * 60 + endM;
  return (endMinutes - startMinutes) / 60;
};
